import axios from './axios';

const getWebsocketToken = () =>
  axios({
    method: 'get',
    url: '/v1/ws/token'
  });

export { getWebsocketToken };
